// extracted by mini-css-extract-plugin
export default {"container":"OnwardJourney_container__T5as1"};